import React from "react";
import { CardFooter } from "reactstrap";

import { resetStore, setIsPrinterModified } from "./store";
import { setIsModalConfirmationOpened } from "@components/VerticalLayout/store";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";

import { usePrepheralCardFooter } from "./usePrepheralCardFooter";

import "./index.css";

type PrepheralCardFooterType = {
    dataIsUpdated: boolean | number;
    setIsEdited: Function;
    setIsDeviceAssociateModalOpened: Function;
    isDeviceAssociateModalOpened: boolean;
    rowData: any;
    setDataIsUpdated: Function;
    selectedRows?: any;
    isPrinter?: boolean;
};

function PrepheralCardFooter({
    dataIsUpdated,
    setIsEdited,
    setIsDeviceAssociateModalOpened,
    isDeviceAssociateModalOpened,
    rowData,
    setDataIsUpdated,
    selectedRows,
    isPrinter = false,
}: PrepheralCardFooterType) {
    const {
        t,
        isLoadingAssociateValidation,
        isModalConfirmationOpened,
        checkModificationEffect,
        handleValidateButtonClickEvent,
    } = usePrepheralCardFooter({
        dataIsUpdated,
        setIsEdited,
        setIsDeviceAssociateModalOpened,
        isDeviceAssociateModalOpened,
        rowData,
        setDataIsUpdated,
        selectedRows,
        isPrinter,
    });

    return (
        <div>
            <CardFooter className="Card-footer__clz">
                <div className="justify-content-between d-flex align-items-right  float-right">
                    <CustomSecondaryColorButton
                        outline
                        rounded
                        className="mr-2 afa_btn_cancelPopup"
                        variant="light"
                        onClick={() => {
                            setIsDeviceAssociateModalOpened(
                                !isDeviceAssociateModalOpened
                            );
                            setDataIsUpdated(!dataIsUpdated);
                            resetStore();
                        }}
                    >
                        <span> {t("Cancel")}</span>
                    </CustomSecondaryColorButton>
                    <CustomMainColorButton
                        rounded
                        variant="primary"
                        className="afa_btn_validatePopup"
                        disabled={isLoadingAssociateValidation}
                        onClick={() => {
                            if (checkModificationEffect === true) {
                                handleValidateButtonClickEvent();
                            } else {
                                setIsModalConfirmationOpened(
                                    !isModalConfirmationOpened
                                );
                            }
                            setIsPrinterModified(false);
                        }}
                    >
                        {t("Validate")}
                    </CustomMainColorButton>
                </div>
            </CardFooter>
        </div>
    );
}

export default PrepheralCardFooter;
